<div class="container">
  <div class="card">
    <div class="card-body">
      <div class="card col-md-12">
        <div class="card-header"><h2 class="orange-border">Payment Details</h2></div>

        <form [formGroup]="form">
          <div class="row">
            @if (isCustomRefEnabled) {
              <div class="form-group col-md-6">
                <label for="customReferenceNumber">Custom Reference/Account Number:</label>
                <input [ngClass]="{ 'is-invalid': displayError(f.customReferenceNumber) }"
                  class="form-control"
                  formControlName="customReferenceNumber"
                  id="customReferenceNumber"
                  maxlength="14"
                  onlyNumbers="true"
                  type="text"/>
                @if (displayError(f.customReferenceNumber)) {
                  <div class="invalid-feedback">
                    @if (f.customReferenceNumber.errors.required) {
                      <div>Reference/Account number required
                      </div>
                    }
                    @if (f.customReferenceNumber.errors.pattern) {
                      <div>Reference/Account number should
                        contain digits 0-9 only.
                      </div>
                    }
                    @if (f.customReferenceNumber.errors.duplicateAccountNumber) {
                      <div>Reference/Account
                        already in use/reserved.
                      </div>
                    }
                  </div>
                }
              </div>
            }
            <div class="form-group col-md-6">
              <label for="reference">Reference Number (e.g. Invoice Number):</label>
              <input [ngClass]="{ 'is-invalid': displayError(f.referenceNumber) }"
                class="form-control"
                formControlName="referenceNumber"
                id="reference"
                type="text"/>
              @if (displayError(f.referenceNumber)) {
                <div class="invalid-feedback">
                  @if (f.referenceNumber.errors.required) {
                    <div>Reference is required</div>
                  }
                </div>
              }
            </div>
            @if (!isQuickPay) {
              <div class="form-group col-md-6">
                <label for="description">Description of the Service or Product:</label>
                <input class="form-control" formControlName="description" id="description" type="text"/>
              </div>
            }
          </div>

          @if (isQuickPay) {
            <div class="row">
              <div class="form-group col-md-6">
                <label for="quickPayAmount">Amount:</label>
                <div class="currency-input-wrapper">
                    <span class="currency-prefix">R </span>
                    <input appCurrencyMask
                           (blur)="calculateTotalAmount()"
                           class="form-control currency-input"
                           formControlName="quickPayAmount"
                           id="quickPayAmount"
                           placeholder="Amount"
                           type="text"/>
                </div>
            </div>
          </div>
        }

        @if (!isQuickPay) {
          <div formArrayName="lineItems">
            <div class="card-header"><h3 class="orange-border">List of Items:</h3></div>
            <div class="disabled-tooltip-wrapper center"
              pTooltip="Add item with a description and an amount excluding VAT.">
              <button (click)="addEmptyLineItem()"
                class="navy-btn center btn-margin-top-bottom"
                type="button">
                Add Item&nbsp; <i class="fas fa-plus fa-sm"></i>
              </button>
            </div>
            @if (f.lineItems?.value.length > 0) {
              <div>
                @for (lineItem of f.lineItems.controls; track lineItem; let i = $index) {
                  <div class="item-card">
                    <div [formGroupName]="i" class="row item-card-body">
                      <div class="col-sm-12 col-md-3 flexible-container">
                        <div class="currency-input-wrapper">
                            <span class="currency-prefix">R </span>
                            <input appCurrencyMask
                                   (blur)="calculateTotalAmount()"
                                   class="form-control currency-input"
                                   formControlName="amount"
                                   id="amount"
                                   placeholder="Amount"
                                   type="text"/>
                        </div>
                      </div>
                      <div class="col-sm-12 col-md-8 flexible-container">
                        <input [ngClass]="{ 'is-invalid': displayArrayElementError(f.lineItems, i, 'description') }"
                          class="form-control"
                          formControlName="description"
                          id="lineItemDescription"
                          placeholder="Item Description"
                          type="text"/>
                        @if (
                          displayArrayElementError(f.lineItems, i, 'description')) {
                          <div
                            class="invalid-feedback">
                            @if (f.lineItems.controls[i].get('description').errors.required) {
                              <div>
                                Description is required
                              </div>
                            }
                            @if (f.lineItems.controls[i].get('description').errors.maxlength) {
                              <div>
                                Description has a maximum length of 90 characters
                              </div>
                            }
                          </div>
                        }
                      </div>
                      <div class="col-sm-10 col-md-1 btn-flexible-container center">
                        <button (click)="removeLineItem(i)"
                          class="navy-btn btn-flexible center"
                          type="button">
                          <i class="fas fa-minus"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }

        <div class="row">
          <div class="form-group col-md-6">
            <validation [formGroup]="form"
              controlName="totalAmountExclVat"
              displayName="Total amount excluding VAT.">
              <label [ngClass]="{ 'is-invalid': displayError(f.totalAmountExclVat) }" class="large">
              Total Amount (Excl. VAT): R {{ f.totalAmountExclVat.value }}&nbsp; </label> <i
              aria-label="total amount tool-tip"
              class="pi pi-question-circle tooltip-icon"
                                    pTooltip="For non-VAT registered businesses, this amount
                             will be displayed in the dashboard and sent in all request to pay transactions."></i>
          </validation>
        </div>

        <div [hidden]="!isVatRegistered" class="form-group col-md-6">
          <validation [formGroup]="form"
            controlName="amountInclVat"
            displayName="Amount including VAT.">
            <label [ngClass]="{ 'is-invalid': displayError(f.amountInclVat) }" class="large"> Total
            Amount (Incl. VAT): R {{ f.amountInclVat.value }}&nbsp; </label>
            <i aria-label="total amount tool-tip"
              class="pi pi-question-circle tooltip-icon"
                                   pTooltip="VAT calculated at 15%. For VAT registered businesses, this amount
                             will be displayed in the dashboard and sent in all request to pay transactions."></i>
          </validation>
        </div>
      </div>
      <div class="row">
        @if (isMultiPremiumEnabled) {
          <div class="form-group col-md-6">
            <validation [formGroup]="form"
              controlName="multiPremiumOption"
              displayName="Multi premium option">
              <label for="multiPremiumOption">Multi Premium Option:&nbsp;</label>
                                    <i class="pi pi-question-circle tooltip-icon" pTooltip="The number of payments the customer is allowed to pay upfront.
                                       For example, if the request is R30 and the value is 3, customers can pay R30, R60, or R90."></i>
              <p-select [options]="multiPremiumOptions"
                [ngClass]="{ 'is-invalid': displayError(f.multiPremiumOption)}"
                class="form-control"
                formControlName="multiPremiumOption"
                id="multiPremiumOption"
                optionLabel="value"
                optionValue="value"
                placeholder="-- Select multi premium option --"/>
            </validation>
          </div>
        } @else if (!isQuickPay) {
          <div class="form-group col-md-6">
            <label for="allowPartialPayments">Allow Partial Payment: </label>
                                <i class="pi pi-question-circle tooltip-icon" pTooltip="If enabled, customers will be allowed to pay any amount between the minimum
                             allowed (R{{minimumRequestToPayAmount?.toFixed(2)}}) and the total."></i>
            <div class="form-inline">
              <p-toggleswitch [(ngModel)]="allowPartialPayments"
                [ngModelOptions]="{standalone: true}"
              id="allowPartialPayments"></p-toggleswitch>
              <h4 class="margin-toggle">{{ isAllowPartialPayments() }}</h4>
            </div>
          </div>
        }
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <validation [formGroup]="form" controlName="customer" displayName="Client name">
            <label for="customer">Client Name:</label>
            <input [ngClass]="{ 'is-invalid': displayError(f.customer)}"
              class="form-control"
              formControlName="customer"
              id="customer"
              type="text"/>
          </validation>
        </div>

        @if (!isQuickPay) {
          <div class="form-group col-md-6">
            <label for="email">Client Email:</label>
            <input [ngClass]="{ 'is-invalid': displayError(f.customerEmail) }"
              class="form-control"
              formControlName="customerEmail"
              id="email"
              type="text"/>
            @if (displayError(f.customerEmail)) {
              <div class="invalid-feedback">
                @if (f.customerEmail.errors.required) {
                  <div>Email is required</div>
                }
                @if (f.customerEmail.errors.email) {
                  <div>Invalid email</div>
                }
              </div>
            }
          </div>
        }

        <div class="form-group col-md-6">
          <validation [formGroup]="form" controlName="customerMobileNumber" displayName="Mobile number">
            <label for="clientMobileNumber">Client Mobile Number:</label>
            <input [ngClass]="{ 'is-invalid': displayError(f.customerMobileNumber) }"
              class="form-control"
              formControlName="customerMobileNumber"
              id="clientMobileNumber"
              placeholder="0831234567 or +27831234567"
              type="tel"/>
          </validation>
        </div>
        <div class="form-group col-md-6">
          <label for="customerVatNumber">Client VAT Number:</label>
          <input [ngClass]="{ 'is-invalid': displayError(f.customerVatNumber) }"
            class="form-control"
            formControlName="customerVatNumber"
            id="customerVatNumber"
            pTooltip="Enter VAT number or leave empty if non-VAT"
            placeholder="non-VAT"
            type="text"/>
        </div>
      </div>
      <div class="row">
        @if (!isQuickPay) {
          <div class="form-group col-md-6">
            <label for="expiryPeriod">Request to Pay Transaction Expiry Period (Days):</label> <input
            [ngClass]="{ 'is-invalid': displayError(f.expiryPeriod) }"
            class="form-control"
            formControlName="expiryPeriod"
            id="expiryPeriod"
            onlyNumbers="true"
            type="text"/>
          @if (displayError(f.expiryPeriod)) {
            <div
              class="invalid-feedback pt-2">
              @if (f.expiryPeriod.errors.pattern) {
                <div>Should contain digits 0-9 only.</div>
              }
              @if (f.expiryPeriod.errors.maxValue) {
                <div>
                  Maximum number of days {{ isEditMode ? 'left' : 'allowed' }}
                  is {{ maximumExpiryPeriod }}.
                </div>
              }
            </div>
          } @else {
            <div class="pt-2">
              This request to pay transaction will expire
              on {{ expiryDate | amFromUtc | amLocal | amDateFormat: 'YYYY-MM-DD HH:mm:ss' }}
            </div>
          }
        </div>
      }
    </div>
    <div>
      <div class="card-header"><h3 class="orange-border">Payment Notification</h3></div>
    </div>
    <div class="row">
      <div class="form-group col-md-6">
        <label for="sendPaymentNotification">Receive Payment Notification: </label>
                            <i class="pi pi-question-circle tooltip-icon" pTooltip="If enabled, an SMS notification will be sent to the provided
                             number when a payment is made to this request to pay transaction."></i>
        <div class="form-inline">
          <p-toggleswitch (ngModelChange)="updateNotificationMobileNumber($event)"
            [ngModelOptions]="{standalone: true}"
            [ngModel]="sendPaymentNotification"
          id="sendPaymentNotification"></p-toggleswitch>
          <h4 class="margin-toggle">{{ isPaymentNotificationEnabled() }}</h4>
        </div>
      </div>
      @if (isQuickPay) {
        <div class="col-md-6">
          <span class="pt-2">
            <strong>This request to pay transaction will expire on {{ expiryDate | amFromUtc | amLocal | amDateFormat: 'YYYY-MM-DD HH:mm:ss' }}</strong>
          </span>
        </div>
      }
    </div>
    @if (sendPaymentNotification) {
      <div class="row">
        <div class="form-group col-md-6">
          <validation [formGroup]="form" controlName="notificationMobileNumber" displayName="Notification mobile number">
            <label for="clientMobileNumber">Notification Mobile Number:</label>
            <input [ngClass]="{ 'is-invalid': displayError(f.notificationMobileNumber) }"
              class="form-control"
              formControlName="notificationMobileNumber"
              id="notificationMobileNumber"
              placeholder="0831234567 or +27831234567"
              type="tel"/>
          </validation>
        </div>
      </div>
    }

    <div class="row">
      <button (click)="cancel()"
        class="navy-btn center btn-margin-top-bottom"
        type="button">{{ cancelButtonText }}&nbsp; <i class="fa fa-close fa-lg"></i>
      </button>

      <div [pTooltip]="isSubscriptionValid && !isGuestAdminUser() ? null : getTooltipText"
        class="disabled-tooltip-wrapper center">
        <button (click)="onSubmitAccount()"
          [disabled]="isGuestAdminUser() || !isSubscriptionValid || !isVatRateLoaded"
          class="navy-btn btn-margin-top-bottom">
          {{ acceptButtonText }}&nbsp; <i class="fa fa-save fa-lg"></i>
        </button>
      </div>
    </div>
  </form>
</div>
</div>
</div>
</div>